import { StringKeyDictionary } from "../app/commonInterfaces.js";
import { Helper } from "../app/core/util/helper.js";

const eventCallbacks: StringKeyDictionary<EventCallback[]> = {};


const bind = (event: EventType, callback: EventCallback) => {
    if (!eventCallbacks[event]) {
        eventCallbacks[event] = [];
    }

    eventCallbacks[event].push(callback);
}

const unbind = (event: EventType, callback: EventCallback) => {
    if (Helper.hasValue(callback)) {
        if (Array.isArray(eventCallbacks[event])) {
            const idx = eventCallbacks[event].indexOf(callback);
            if (idx >= 0) {
                eventCallbacks[event].splice(idx, 1);
            }
        }
    }
}

const trigger = (event: EventType, data?: any) => {
    if (Array.isArray(eventCallbacks[event])) {
        //call all the callbacks
        eventCallbacks[event].forEach(c => c(data));
    }
}


export const Manager = {
    bind, unbind, trigger
}


export enum EventType {
    SystemInitialized,
    SheetOpened,
    SheetClosed,
    SheetRemoved,
    ShortCut,
    Custom,
    SavedSuccessfully
}


interface EventCallback<T = any> {
    (data?: T): void;
}